import { Component, inject, signal, Output, EventEmitter, OnInit, ChangeDetectionStrategy, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SeasonsService, Season } from '../../../core/service/seasons-service/seasons.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-season-selector',
  standalone: false,
  templateUrl: './season-selector.component.html',
})
export class SeasonSelectorComponent implements OnInit {
  private seasonsService = inject(SeasonsService);
  private destroyRef = inject(DestroyRef);

  @Output() seasonChange = new EventEmitter<number | null>();

  seasons = signal<Season[]>([]);
  selectedSeasonId = signal<number | null>(null);

  ngOnInit(): void {
    this.seasonsService.list().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (res) => {
        const list: Season[] = res.data || res || [];
        this.seasons.set(list);
        const active = list.find(s => s.sportseason_status === 'ACTI');
        if (active) {
          this.selectedSeasonId.set(active.sportseason_id);
          this.seasonChange.emit(active.sportseason_id);
        }
      },
      error: () => {},
    });
  }

  onSelect(value: string): void {
    const id = value ? parseInt(value, 10) : null;
    this.selectedSeasonId.set(id);
    this.seasonChange.emit(id);
  }
}
